import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import CssBaseline from "@material-ui/core/CssBaseline";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "35vh",
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
  footer: {
    padding: theme.spacing(3, 2),
    marginTop: "auto",
  },
}));

function Copyright() {
  const history = useHistory();
  return (
    <Typography
      display="inline"
      style={{ float: "right" }}
      variant="body2"
      color="textSecondary"
    >
      {"Copyright © "}
      <Link color="inherit" onClick={() => history.push("/")}>
        AIMS
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function PoweredBy() {
  return (
    <Typography variant="body2" display="inline" color="textSecondary">
      {"Powered By  "}
      <Link color="inherit" target="_blank" href="https://cloudville.io">
        Cloudville
      </Link>
    </Typography>
  );
}

export default function LandingPageFooter() {
  // const classes = useStyles();
  // return (
  //   <React.Fragment>
  //     <CssBaseline />
  //     <div className={classes.root}>
  //       <footer className={classes.footer}>
  //         <Container maxWidth="xl">
  //           <PoweredBy />
  //           <Copyright />
  //         </Container>
  //       </footer>
  //     </div>
  //   </React.Fragment>
  // );

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <footer className={classes.footer}>
        <Container maxWidth="xl">
          <PoweredBy />
          <Copyright />
        </Container>
      </footer>
    </div>
  );
}
